<div class="hero is-fullheight">
	<div class="hero-body">
		<div class="container" style="min-height: calc(100vh - 3.8rem)">
			<button (click)="showMenu = !showMenu" class="button filter-button is-hidden-desktop">Filtrar</button>
			<app-equipment *ngFor="let e of (filteredEquipment | async)" [equipment]="e" [showCalifications]="selectedClass === classes.CALIFICATION"></app-equipment>
		</div>
	</div>
</div>

<aside [@slide]="showMenu ? 'opened' : 'closed'" class="menu is-hidden-desktop">
	<p [class.is-active]="selectedClass === classes.CALIBRATION" (click)="selectClass(classes.CALIBRATION)" class="menu-label">
		Calibración
	</p>
	<ul class="menu-list">
		<li *ngFor="let class of (calibrationClasses | enumToArray)">
			<a (click)="selectSubclass(calibrationClasses[class], classes.CALIBRATION)">{{ calibrationClasses[class] | titlecase }}</a>
		</li>
	</ul>
	<p [class.is-active]="selectedClass === classes.CALIFICATION" (click)="selectClass(classes.CALIFICATION)" class="menu-label">
		Calificación
	</p>
	<ul class="menu-list">
		<li *ngFor="let class of (calificationClasses | enumToArray)">
			<a (click)="selectSubclass(calificationClasses[class], classes.CALIFICATION)">{{ calificationClasses[class] | titlecase }}</a>
		</li>
	</ul>
	<p [class.is-active]="selectedClass === classes.TEST" (click)="selectClass(classes.TEST)" class="menu-label">
		Calibración
	</p>
	<ul class="menu-list">
		<li *ngFor="let class of (testClasses | enumToArray)">
			<a (click)="selectSubclass(testClasses[class], classes.TEST)">{{ testClasses[class] | titlecase }}</a>
		</li>
	</ul>
</aside>

<aside class="menu is-hidden-touch">
	<p [class.is-active]="selectedClass === classes.CALIBRATION" (click)="selectClass(classes.CALIBRATION)" class="menu-label">
		Calibración
	</p>
	<ul class="menu-list">
		<li *ngFor="let class of (calibrationClasses | enumToArray)">
			<a (click)="selectSubclass(calibrationClasses[class], classes.CALIBRATION)">{{ calibrationClasses[class] | titlecase }}</a>
		</li>
	</ul>
	<p [class.is-active]="selectedClass === classes.CALIFICATION" (click)="selectClass(classes.CALIFICATION)" class="menu-label">
		Calificación
	</p>
	<ul class="menu-list">
		<li *ngFor="let class of (calificationClasses | enumToArray)">
			<a (click)="selectSubclass(calificationClasses[class], classes.CALIFICATION)">{{ calificationClasses[class] | titlecase }}</a>
		</li>
	</ul>
	<p [class.is-active]="selectedClass === classes.TEST" (click)="selectClass(classes.TEST)" class="menu-label">
		Calibración
	</p>
	<ul class="menu-list">
		<li *ngFor="let class of (testClasses | enumToArray)">
			<a (click)="selectSubclass(testClasses[class], classes.TEST)">{{ testClasses[class] | titlecase }}</a>
		</li>
	</ul>
</aside>